/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { View } from '@az/starc-ui'

import { Item } from '../types'
import ItemSearchBar from './ItemSearchBar/ItemSearch'
import PartSearchCard from './PartSearch/PartSearchCard'

import style from './StoreDetailsPage.module.css'

type State = {
  storeNumber: string
  items: Item[]
  searchTerm: string
}

function StoreDetailsPage() {
  const { storeNumber } = useParams()
  const [state, setState] = useState<State>({
    storeNumber: storeNumber !== undefined ? storeNumber : '',
    items: [],
    searchTerm: ''
  })

  useEffect(() => {
    document.body.style.backgroundColor = '#f2f2f2'
    return () => {
      document.body.style.backgroundColor = '' // Reset to default
    }
  }, [])

  const onChangeItems = (search: string, items: Item[]) =>
    setState(prevState => ({
      ...prevState,
      items,
      searchTerm: search
    }))

  return (
    <View direction="row" padding={0}>
      <View.Item className={style.SearchContainer}>
        <ItemSearchBar setItems={onChangeItems} storeNumber={state.storeNumber} />
      </View.Item>
      <View.Item className={style.SearchContainer}>
        <PartSearchCard items={state.items} searchTerm={state.searchTerm} />
      </View.Item>
    </View>
  )
}
export default StoreDetailsPage
